import React, { Component } from 'react';
import _ from "lodash";
import EditClient from './EditClient';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
class ClientData extends Component {
  constructor(props){
    super(props)
    this.state={
      centerData:props ? props.centerData :[]
    }
  }
  componentWillMount = () => {
    const {centerData} = this.state;
    let obj = [
      {
        "contactDetailsId": "",
        "email": "",
        "mobileNumber": "",
        "notificationStatus": "ACTIVE",
        "personName": "",
        "status": "ACTIVE",
        "clientReportMaps": [      
        ]
      }]
    if(_.isNull(centerData.contactDetails) || _.isEmpty(centerData.contactDetails)){
      this.setState({contactPersonDetails:obj})
    } else {
      this.setState({contactPersonDetails:centerData.contactDetails})
    }  
     
  }
  handleChange = (e, i) =>{
    const{contactPersonDetails} = this.state;    
    let indexed = contactPersonDetails[i]
    indexed[e.target.id] = e.target.value
    this.setState({contactPersonDetails}, ()=>this.sendCallbackFunction())
  }
  sendCallbackFunction = () => {
    let center = _.cloneDeep(this.state.centerData);
    center.contactDetails = this.state.contactPersonDetails
    this.props.onCallBackFunction(center)
  }
  duplicateItems = () => {
    const{contactPersonDetails} = this.state;
      let obj = _.clone(contactPersonDetails[0])
      obj.contactDetailsId = '';
      obj.email=''; obj.mobileNumber = '';
      obj.personName = '';
      obj.clientReportMaps =[]
      obj.status = 'ACTIVE'
      contactPersonDetails.push(obj)
    this.setState({contactPersonDetails})
  }
  removeduplicateItems = (i) => {
    if(i !== 0){
    const{contactPersonDetails} = this.state;
    let obj = contactPersonDetails[i]
    obj.status = 'INACTIVE'
    this.setState({contactPersonDetails})
    }
  }
  chooseReportsModal = (i) => {
    this.setState({["showModal"+i]:true})
  }
  chooseReportsModalClose = (i) => {
    this.setState({["showModal"+i]:false})
  }
  handleReports = (index, selectReports) =>{
    const{contactPersonDetails, centerData} = this.state
    contactPersonDetails[index].clientReportMaps = selectReports
    let center = _.cloneDeep(centerData);
    center.contactDetails = contactPersonDetails
    this.setState({centerData:center},()=>this.sendCallbackFunction())
  }
  fileSelecthandler = event => {
    const {centerData} = this.props;    
    centerData.logoName = event.target.files[0].name
    this.getBase64(event.target.files[0], (result) => {
     let idCardBase64 = result;   
     centerData.logo = idCardBase64     
     this.setState({centerData}, ()=>this.sendCallbackFunction())
   });   
    
  }
  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
    };
    
}
  handleNotification = (e, i) => {
    const{contactPersonDetails, centerData} = this.state; 
    if(e.target.checked){
      contactPersonDetails[i].notificationStatus = 'ACTIVE'
    }else{
      contactPersonDetails[i].notificationStatus = 'INACTIVE'
    }
    let center = _.cloneDeep(centerData);
    center.contactDetails = contactPersonDetails
    this.setState({centerData:center},()=>this.sendCallbackFunction())
  }
  isValidEmailAddress = (address) =>{
    if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)){
      return true
    } else {
      return false
    }
  }
  
  centerBody = (centerData) => {  
   const{contactPersonDetails} = this.state;   
   let obj = _.map(contactPersonDetails, (newobj, i) => {
    return(
      <tr className={(newobj.status === "INACTIVE") ? "disabled" : ""}>
        {(i === 0 ) ?
      <th className='widthSpecific firstClass'>
        <Picky keepOpen={false}
          value={centerData.inventoryCenterName}
         // options={this.props.selected.centers}
        //  onChange={this.handleRegions}
          open={false}
          valueKey="label"
          labelKey="label"
          multiple={false}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Centers'
          dropdownHeight={600}
          disabled
        /> </th> : <th className='noheader'></th> }
        { (i === 0 ) ? <th className='widthSpecific'>
        <ul>
        { _.map(centerData.processes, (li) =>{
        return(<li>{li.inventoryProcessName}</li>)
        }) } 
        </ul> </th>  : <th  className='noheader'></th> }
        { (i === 0 ) ?      
      <th className='widthSpecific'>
          <div>
          <input id='logo' label='Choose logo' style={{display:"none"}} ref={fileInput =>this.fileInput = fileInput}
          onChange={(e)=>this.fileSelecthandler(e)} type='file'/>         
          <i class="fas fa-upload alignRight" style={{padding:'3.5px'}} onClick={()=>this.fileInput.click()}/>
          {!_.isNull(centerData.logo) ? <img src={centerData.logo} alt='clientlogo'/> : null}
          {!_.isNull(centerData.logoName) ? centerData.logoName : null }
          </div>
      </th>
        : <th  className='noheader'></th> }     
        <td  className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>
        <input className='form-control' id='personName' placeholder='name' value={newobj ? newobj.personName  : null}
        onChange={(e)=>this.handleChange(e, i)}
            type='text'/>
      </td>
      <td  className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>
       <input className='form-control' id='mobileNumber' placeholder='contactNumber' value={newobj ? newobj.mobileNumber : null}
       onChange={(e)=>this.handleChange(e, i)}
       type='number'/>
     </td>
     <td  className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>
        <input className='form-control' id='email' placeholder='email' value={newobj ? newobj.email : null}
          onChange={(e)=>this.handleChange(e, i)}
          onBlur={() => this.setState({["emailIsValid"+i] : this.isValidEmailAddress(newobj.email ) }) }
          type='email'/>
          {(this.state['emailIsValid'+i] === false) ? <span className="RedColoring">&nbsp;****Enter valid email****</span>: null}
      </td>
      <td className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>
          <p onClick={()=>this.chooseReportsModal(i)} className="cursorPointer">Click to Select Reports</p>
          { this.state["showModal"+i] ?
            <EditClient 
              callBack={(a)=>this.handleReports(i, a)}
              selected = {newobj.clientReportMaps}
              Reports={this.props.reportlist}
              process={centerData.processes}
              freqlist={this.props.freqlist}
              //contactPerson={val}
              handleClose={()=>this.chooseReportsModalClose(i)}/>
            :null
          }
      </td>
      <td className={(i === 0 ) ? 'widthSpecific' : ' widthSpecific noheader'}>
      <i className='fas fa-plus-circle accord' onClick={this.duplicateItems} />
      <i className="fas fa-minus-circle accord" onClick={()=>this.removeduplicateItems(i)} />
      </td>
      <br/>
     </tr>  
      )     
     }) 
     return obj
     
     
    
  }
  render(){
    const{centerData} = this.state
    return( 
     this.centerBody(centerData)
    );
  }
}

export default ClientData

